import LegislativnyMaterialList from './LegislativnyMaterialList';

export default LegislativnyMaterialList;
